// Claim USDT for all participants

import {useState, useEffect, useRef} from "react";
import {
	Box,
	useToast,
	Button
} from "@chakra-ui/react";
import {
	participants,
	getClaimableAmount,
	getClaimedAmount,
	fromWei,
	format,
	NusicVault,
} from "../../utils/common";
import {
	PAYMENT_TOKEN_SYMBOL,
} from "../../config";
import { useAuth } from "../../contexts/AuthContext";
import ConfirmationProgress from "../../components/ConfirmationProgress";
import intl from "../../utils/intl";
// import {Shareholders} from "../Shareholders";

const ClaimPaymentTokenBody = () => {
	const [claimables, setClaimables] = useState([]);
	const toast = useToast();
  const { currentAccount, setCurrentAccount, currentNetwork } = useAuth();
	const [ hiddenConfirmationProgress, setHiddenConfirmationProgress ] = useState(true);
	const [ confirmationProgressData, setConfirmationProgressData ] = useState({value: 5, message: intl.get("start"), step: 1});
	const loaded = useRef(false);
	
	// DEBUG, for checking other account's releasable amount
	// setCurrentAccount('0x615b80388E3D3CaC6AA3a904803acfE7939f0399');

	const getClaimableAmounts = (async() => {
		if(currentAccount === undefined) return;
		let _claimables = [];
		for(let i = 4; i <= 8; i++) {
			// Check participant id from 4 to 8 (Mainnode, tinynode, tech, community, liquidity)
			const claimable = await getClaimableAmount(i, currentAccount);
			const claimed = await getClaimedAmount(i, currentAccount);
			_claimables.push({
				participantId: i,
				name: participants[i].name,
				// tokenId: params.tokenId,
				claimable,
				claimed
			})
		}
		setClaimables(_claimables);
	});

	useEffect(() => {
		if(!loaded.current && currentAccount !== undefined) {
			getClaimableAmounts();
			return() => loaded.current = true;	
		}
	}, [currentAccount, currentNetwork])

	const bg = "#08152b";

	const showError = (msg) => {
		toast({
			title: intl.get("error"),
			description: msg,
			status: "error",
			duration: 4000,
			isClosable: true
		})
	}

	const showSuccess = (msg) => {
		toast({
			title: intl.get("success"),
			description: msg,
			status: "success",
			duration: 4000,
			isClosable: true
		})
	}

	const claim = async (id) => {
		const _claimable = claimables[id];
		setHiddenConfirmationProgress(false);
		setConfirmationProgressData({step: '1/2', value: 10, message: intl.get("start")});
		try {
			const tx = await NusicVault().withdraw(_claimable.participantId, _claimable.claimable);
			await tx.wait();
			setConfirmationProgressData({step: '2/2', value: 100, message: intl.get("claiming_payment")});
			showSuccess(intl.get("claim_success"));

			setTimeout(() => {
				setHiddenConfirmationProgress(true);
			}, 4000);	
		} catch (err) {
			showError(err.message);
			setHiddenConfirmationProgress(true);
		}
	}

	return(
		<Box>
		{currentAccount === undefined || claimables.length === 0 ? <></> :
		<Box mt={20}>
			{/* <Box mt={10} w={"32%"} ml={"34%"} color={"white"}>
				{intl.get("current_account") + ": " + currentAccount}
			</Box> */}
			{claimables.map((v, i) => {
				if(v.claimable === undefined || (v.claimable * 1 === 0 && v.claimed * 1 === 0)) return(<Box key={i}></Box>);
				return(
					<Box key={i}>
						<Box
							bg={bg}
							w={"32%"}
							ml={"34%"}
							mt={8}
							p={5}
							borderRadius={10}
							border={"1px solid"}
							borderColor={bg}
							color={"white"}
						>
							<Box mb={3}>
								{v.name}
							</Box>
							<Box mb={3}>
								{intl.get("claimable") + ": " + format(fromWei(v.claimable), 4) + " " + PAYMENT_TOKEN_SYMBOL}
							</Box>
							<Box mb={3}>
							 	{intl.get("claimed") + ": " + format(fromWei(v.claimed), 4) + " " + PAYMENT_TOKEN_SYMBOL}
							</Box>
							{/* <Box mb={3}>
								<InputGroup size='md'>
									<InputLeftAddon children='USDT' color={"black"} />
									<Input placeholder='Claim amount' />
								</InputGroup>
							</Box> */}
							<Button disabled={v.claimable * 1 === 0} mt={3} size="md" w={"40%"} bg={"#815cd3"} onClick={() => claim(i)}>
								{intl.get("claim")}
							</Button>
						</Box>
					</Box>
				)
			})}
		</Box>}
		{/* <Box color={"white"} w={"32%"} ml={"34%"} mt={10}>
			<Shareholders/>
		</Box> */}
		{hiddenConfirmationProgress ? <></> :
		<Box color={"white"} w={"32%"} ml={"34%"}>
			<ConfirmationProgress 
				step={confirmationProgressData.step}
				value={confirmationProgressData.value}
				message={confirmationProgressData.message}
			/>
		</Box>}
		</Box>
	)
}

export default ClaimPaymentTokenBody;